import { useState } from "react";
import { Box, Button, Flex, HStack, Text, VStack, CloseButton } from "@chakra-ui/react";
import Link from "next/link";
import { AnimatePresence, motion } from "framer-motion";
// Icons
import { Building, ChevronDown, ChevronUp } from 'lucide-react';
// import { FaBuilding } from "react-icons/fa";
// import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

// Components
import { useAuth } from "hooks/auth";
import { menuItemsData, institucionalItemsData } from "data/siteData";
import { MobileLeftSidebarProps } from "../../../types/common";
import { CustomDialog } from "components/ui/dialog";
// Styles
import { HeaderComponentsStyles } from "styles/headerStyles";

export default function MobileLeftSidebar({ isOpen, onClose }: MobileLeftSidebarProps) {
  const { isAuthenticated } = useAuth();
  const [isInstitucionalOpen, setIsInstitucionalOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClubLinkClick = () => {
    setIsDialogOpen(true); 
  };

  const handleConfirm = () => {
    window.open(menuItemsData[1].href, "_blank");
    setIsDialogOpen(false);
    onClose(); // Fecha o menu após confirmar
  };

  const handleInstitucionalClick = () => {
    setIsInstitucionalOpen(!isInstitucionalOpen);
  };

  const handleMenuItemClick = () => {
    onClose(); // Fecha o menu ao clicar em qualquer item
  };

  const handleSubmenuItemClick = () => {
    onClose(); // Fecha o menu ao clicar em um item do submenu
  };

  if (!isOpen) return null;

  return (
    <>
      <Box {...HeaderComponentsStyles.leftSidebarMobile.mobileMenuBox}>
        <Flex {...HeaderComponentsStyles.leftSidebarMobile.mobileMenuHeader}>
          <Box {...HeaderComponentsStyles.leftSidebarMobile.mobileMenuHeaderText}>Menu</Box>
          <CloseButton onClick={onClose} size="lg" />
        </Flex>
        <Box h="1px" bg="gray.300" my="2" w="full" />
        <VStack align="stretch" px={4} mt="4">
          {/* Institucional Item com Dropdown */}
          <Button 
            {...HeaderComponentsStyles.leftSidebarMobile.institucionalItemButton} 
            onClick={handleInstitucionalClick}
          >
            <HStack>
              <Building size={18} />
              <Text>Institucional</Text>
            </HStack>
            {isInstitucionalOpen ? 
              <ChevronUp size={18} /> : 
              <ChevronDown size={18} />
            }
          </Button>
          <AnimatePresence>
          {/* Institucional Submenu */}
          {isInstitucionalOpen && (
            <Box {...HeaderComponentsStyles.leftSidebarMobile.institucionalSubmenuBox}>
              {institucionalItemsData.map((item) => (
                <Link key={item.label} href={item.href} passHref legacyBehavior>
                  <Button 
                    as="a" 
                    {...HeaderComponentsStyles.leftSidebarMobile.institucionalSubmenuItem}
                    onClick={handleSubmenuItemClick} // Fecha o menu ao clicar
                    display="flex"
                    flexDir="column"
                    alignItems="flex-start"
                    width="100%"
                  >
                    <Text fontWeight="bold">{item.label}</Text>
                  </Button>
                </Link>
              ))}
            </Box>
          )}
          </AnimatePresence>

          {/* Regular Menu Items */}
          {menuItemsData.map(({ label, icon: Icon, href }) => {
            // if (label === "Consultar Associado" && !isAuthenticated) {
            //   // Se for esse item e o user não estiver logado, não renderiza nada
            //   return null;
            // }

            if (label === "Clube de Benefícios") {
              return (
                <Button 
                  key={label} 
                  onClick={handleClubLinkClick} 
                  {...HeaderComponentsStyles.leftSidebarMobile.mobileMenuItemButton}
                >
                  <HStack>
                    <Icon size={18} />
                    <Text>{label}</Text>
                  </HStack>
                </Button>
              );
            }

            return (
              <Link key={label} href={href} passHref legacyBehavior>
                <Button 
                  as="a"
                  onClick={handleMenuItemClick} // Fecha o menu ao clicar
                  {...HeaderComponentsStyles.leftSidebarMobile.mobileMenuItemButton}
                >
                  <HStack>
                    <Icon size={18} />
                    <Text>{label}</Text>
                  </HStack>
                </Button>
              </Link>
            );
          })}
        </VStack>
      </Box>

      {/* Overlay */}
      <Box {...HeaderComponentsStyles.leftSidebarMobile.mobileMenuOverlay} onClick={onClose} />

      {/* Custom Dialog for Club Link */}
      <CustomDialog
        open={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false);
          onClose(); // Fecha o menu se cancelar o diálogo
        }}
        title="COMUNICADO IMPORTANTE"
        titleBg="orange.500"
        body="A AAJUMP esclarece que tem formalizado alguns convênios com prestadores de serviços e/ou empresas com intuito de gerar benefícios para os seus associados. Porém, nossa associação não tem qualquer responsabilidade pela prestação de serviço ou aquisição de produtos dos conveniados, sendo a contratação de inteira responsabilidade do associado."
        body2="Ao concordar, você será redirecionado para a nossa página de convênios chamada Clube de Benefícios."
        onConfirm={handleConfirm}
        onCancel={() => {
          setIsDialogOpen(false);
          onClose(); // Fecha o menu ao cancelar
        }}
      />
    </>
  );
};